var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "gutter-sm",
      class: _vm.$q.screen.lt.md && !_vm.showFiltersMobile ? "column" : "row"
    },
    [
      _vm.withFilters && (_vm.$q.screen.lt.md || _vm.showFiltersDesktop)
        ? _c(
            "div",
            {
              class:
                _vm.$q.screen.lt.md && !_vm.showFiltersMobile
                  ? "col-auto"
                  : "col-md-3"
            },
            [
              _c(
                "q-card",
                { class: _vm.$q.screen.gt.sm ? "full-height" : "" },
                [
                  _c("q-card-title", [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col" }, [
                        _vm._v("\n            Filters\n          ")
                      ]),
                      _vm.$q.screen.lt.md
                        ? _c(
                            "div",
                            { staticClass: "col-auto q-mr-auto" },
                            [
                              _c("q-btn", {
                                attrs: {
                                  color: "secondary",
                                  flat: "",
                                  round: "",
                                  icon:
                                    "keyboard_arrow_" +
                                    (_vm.showFiltersMobile ? "up" : "down")
                                },
                                on: { click: _vm.toggleFiltersMobile }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  ]),
                  _vm.$q.screen.gt.sm || _vm.showFiltersMobile
                    ? _c(
                        "q-card-main",
                        { staticStyle: { height: "calc(100% - 64px)" } },
                        [
                          _vm.$q.screen.gt.sm
                            ? _c(
                                "q-scroll-area",
                                { staticClass: "full-height" },
                                [
                                  _c("bj-filters", {
                                    key: _vm.filtersResetReRenderKey,
                                    ref: "filtersModal",
                                    attrs: {
                                      fields: _vm.filterFields,
                                      statuses: _vm.$config.tourStatuses
                                    },
                                    on: {
                                      reset: function($event) {
                                        _vm.filtersResetReRenderKey++
                                      },
                                      input: _vm.initPage1
                                    },
                                    model: {
                                      value: _vm.filters,
                                      callback: function($$v) {
                                        _vm.filters = $$v
                                      },
                                      expression: "filters"
                                    }
                                  })
                                ],
                                1
                              )
                            : _c("bj-filters", {
                                key: _vm.filtersResetReRenderKey,
                                ref: "filtersModal",
                                attrs: {
                                  fields: _vm.filterFields,
                                  statuses: _vm.$config.tourStatuses
                                },
                                on: {
                                  reset: function($event) {
                                    _vm.filtersResetReRenderKey++
                                  },
                                  input: _vm.initPage1
                                },
                                model: {
                                  value: _vm.filters,
                                  callback: function($$v) {
                                    _vm.filters = $$v
                                  },
                                  expression: "filters"
                                }
                              })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "col" },
        [
          _c("q-table", {
            ref: "quasarTable",
            staticClass: "sticky-header-table",
            attrs: {
              data: _vm.tours,
              columns: _vm.columns,
              "visible-columns": _vm.visibleColumns,
              separator: "cell",
              "row-key": "id",
              color: "primary",
              loading: _vm.loading,
              "no-data-label": "Tours not found",
              "no-results-label": "Tours not found",
              "loading-label": "Fetching tours...",
              pagination: _vm.pagination,
              "rows-per-page-options": [25, 50, 100, 250]
            },
            on: {
              "update:pagination": function($event) {
                _vm.pagination = $event
              },
              request: _vm.request
            },
            scopedSlots: _vm._u([
              {
                key: "top-left",
                fn: function(props) {
                  return [
                    _vm.$q.screen.gt.sm
                      ? _c(
                          "div",
                          [
                            _vm.withFilters
                              ? _c("q-btn", {
                                  directives: [
                                    { name: "tippy", rawName: "v-tippy" }
                                  ],
                                  staticClass: "q-mr-md",
                                  attrs: {
                                    rounded: "",
                                    icon: "filter_list",
                                    color: "secondary",
                                    title: "Show/Hide filters"
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.toggleFiltersDesktop($event)
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                }
              },
              {
                key: "bottom-row",
                fn: function(props) {
                  return [
                    _c("div", { staticClass: "q-mr-sm font-small" }, [
                      _vm._v(
                        "\n          Displaying " +
                          _vm._s(_vm.totalResults) +
                          " tours\n        "
                      )
                    ])
                  ]
                }
              },
              {
                key: "body-cell-id",
                fn: function(props) {
                  return [
                    _c("q-td", { attrs: { props: props } }, [
                      _vm._v(
                        "\n          " + _vm._s(props.value) + "\n        "
                      )
                    ])
                  ]
                }
              },
              {
                key: "body-cell-schedule",
                fn: function(props) {
                  return [
                    _c("q-td", { attrs: { props: props } }, [
                      _vm._v(
                        "\n          " + _vm._s(props.value) + "\n        "
                      )
                    ])
                  ]
                }
              },
              {
                key: "body-cell-property",
                fn: function(props) {
                  return [
                    _c(
                      "q-td",
                      { attrs: { props: props } },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                name: "app.properties.combined",
                                params: { id: props.value.id }
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(props.value.short_address) +
                                "\n          "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]
                }
              },
              {
                key: "body-cell-unit",
                fn: function(props) {
                  return [
                    _c("q-td", { attrs: { props: props } }, [
                      _c("span", [_vm._v(_vm._s(props.value.name))])
                    ])
                  ]
                }
              },
              {
                key: "body-cell-leads",
                fn: function(props) {
                  return [
                    _c(
                      "q-td",
                      { attrs: { props: props } },
                      _vm._l(props.row.schedule_inquiries, function(
                        scheduleInquiry,
                        index
                      ) {
                        return _c(
                          "div",
                          { key: index },
                          [
                            _c("SdLeadFullName", {
                              attrs: { lead: scheduleInquiry.inquiry.lead }
                            })
                          ],
                          1
                        )
                      })
                    )
                  ]
                }
              },
              {
                key: "body-cell-agent",
                fn: function(props) {
                  return [
                    _c(
                      "q-td",
                      { attrs: { props: props } },
                      [
                        _vm.get(props, "value.id") &&
                        !props.row.is_taken_over &&
                        !props.row.is_self_showing
                          ? _c(
                              "span",
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: {
                                        name: "app.agents.profile",
                                        params: { id: props.value.id }
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(props.value.full_name) +
                                        "\n            "
                                    )
                                  ]
                                ),
                                props.value.blocked
                                  ? _c("i", {
                                      staticClass:
                                        "ml-1 text-red q-icon fa fa-ban"
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : props.row.is_taken_over
                          ? _c(
                              "q-chip",
                              {
                                staticClass: "capitalize",
                                attrs: { color: "purple-4" }
                              },
                              [_vm._v("\n            Taken Over\n          ")]
                            )
                          : props.row.is_self_showing
                          ? _c(
                              "q-chip",
                              {
                                staticClass: "capitalize",
                                attrs: { color: "purple-4" }
                              },
                              [_vm._v("\n            Self Showing\n          ")]
                            )
                          : _c("span", [
                              _vm._v("\n            N/A\n          ")
                            ])
                      ],
                      1
                    )
                  ]
                }
              },
              {
                key: "body-cell-inquiryIds",
                fn: function(props) {
                  return [
                    _c(
                      "q-td",
                      { attrs: { props: props } },
                      _vm._l(props.value, function(id, index) {
                        return _c(
                          "router-link",
                          {
                            key: index,
                            attrs: {
                              to: {
                                name: "app.inquiries.timeline",
                                params: { id: id }
                              }
                            }
                          },
                          [
                            _c("q-btn", {
                              attrs: {
                                rounded: "",
                                outline: "",
                                size: "sm",
                                color: "primary",
                                label: id
                              }
                            })
                          ],
                          1
                        )
                      })
                    )
                  ]
                }
              },
              {
                key: "body-cell-status",
                fn: function(props) {
                  return [
                    _c(
                      "q-td",
                      { attrs: { props: props } },
                      [
                        _c("q-chip", { staticClass: "capitalize" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.value.split("_").join(" ")) +
                              "\n          "
                          )
                        ]),
                        props.row.is_showami
                          ? _c(
                              "q-chip",
                              {
                                staticClass: "ml-2",
                                attrs: {
                                  dense: "",
                                  color: "orange",
                                  "text-color": "white"
                                }
                              },
                              [_vm._v("\n            Showami\n          ")]
                            )
                          : _vm._e(),
                        props.row.is_showami && props.row.tour_url
                          ? _c(
                              "a",
                              {
                                staticClass: "ml-2",
                                attrs: {
                                  href: props.row.tour_url,
                                  target: "_blank"
                                }
                              },
                              [_vm._v("🈶")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                }
              },
              {
                key: "body-cell-showingType",
                fn: function(props) {
                  return [
                    _c("q-td", { attrs: { props: props } }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(props.row.showing_profile_type) +
                          "\n        "
                      )
                    ])
                  ]
                }
              },
              {
                key: "body-cell-reviews",
                fn: function(props) {
                  return [
                    _c(
                      "q-td",
                      {
                        class: props.value.length > 1 ? "p-1" : "",
                        attrs: { props: props }
                      },
                      _vm._l(props.value, function(review, index) {
                        return _c(
                          "div",
                          { key: index },
                          [
                            _c("q-rating", {
                              attrs: { readonly: "" },
                              model: {
                                value: review.score,
                                callback: function($$v) {
                                  _vm.$set(review, "score", $$v)
                                },
                                expression: "review.score"
                              }
                            }),
                            props.value.length > 1
                              ? _c("q-icon", {
                                  directives: [
                                    { name: "tippy", rawName: "v-tippy" }
                                  ],
                                  attrs: {
                                    name: "info",
                                    size: "16px",
                                    color: "blue",
                                    title: "Lead ID: #" + review.owner_model_id
                                  }
                                })
                              : _vm._e(),
                            review.review
                              ? _c("q-icon", {
                                  directives: [
                                    { name: "tippy", rawName: "v-tippy" }
                                  ],
                                  attrs: {
                                    name: "comment",
                                    size: "15px",
                                    title: review.review
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      })
                    )
                  ]
                }
              },
              {
                key: "body-cell-tour_at",
                fn: function(props) {
                  return [
                    _c(
                      "q-td",
                      { attrs: { props: props } },
                      [
                        _c("SdDatetime", {
                          attrs: {
                            value: props.row.tour_at,
                            until: props.row.tour_until,
                            "market-id": props.row.property.market_id,
                            timezone: props.row.property.timezone
                          }
                        }),
                        props.row.is_video
                          ? _c("i", {
                              staticClass: "q-icon fa fa-video",
                              staticStyle: { "margin-left": "5px" }
                            })
                          : _vm._e(),
                        props.row.is_open_house
                          ? _c("i", {
                              staticClass: "q-icon fa fa-users",
                              staticStyle: { "margin-left": "5px" }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                }
              },
              {
                key: "body-cell-City",
                fn: function(props) {
                  return [
                    _c("q-td", { attrs: { props: props } }, [
                      props.row.property.address.data
                        ? _c("span", [
                            _vm._v(
                              _vm._s(props.row.property.address.data.vicinity)
                            )
                          ])
                        : _vm._e()
                    ])
                  ]
                }
              },
              {
                key: "body-cell-transactionId",
                fn: function(props) {
                  return [
                    _c(
                      "q-td",
                      { attrs: { props: props } },
                      [
                        props.row.transactionId
                          ? _c("q-btn", {
                              attrs: {
                                rounded: "",
                                outline: "",
                                size: "sm",
                                color: "primary",
                                label: props.row.transactionId
                              },
                              on: {
                                click: function($event) {
                                  _vm.redirect("app.transactions", {
                                    id: props.row.transactionId
                                  })
                                }
                              }
                            })
                          : _vm._e(),
                        props.row.chargeTransactionId
                          ? _c("q-btn", {
                              attrs: {
                                rounded: "",
                                outline: "",
                                size: "sm",
                                color: "primary",
                                label: props.row.chargeTransactionId
                              },
                              on: {
                                click: function($event) {
                                  _vm.redirect("app.transactions", {
                                    id: props.row.chargeTransactionId
                                  })
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                }
              },
              {
                key: "body-cell-Market",
                fn: function(props) {
                  return [
                    _c("q-td", { attrs: { props: props } }, [
                      props.row.property.market
                        ? _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(props.row.property.market.name) +
                                "\n          "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]
                }
              },
              {
                key: "body-cell-actions",
                fn: function(props) {
                  return [
                    _c(
                      "q-td",
                      { attrs: { props: props } },
                      [
                        props.row.survey_result_id || props.row.timed_out_at
                          ? _c("q-btn", {
                              directives: [
                                { name: "tippy", rawName: "v-tippy" }
                              ],
                              staticClass: "q-ml-sm",
                              attrs: {
                                to: {
                                  name: "app.tours.survey-result",
                                  params: { id: props.row.id }
                                },
                                size: "sm",
                                rounded: "",
                                outline: "",
                                color: "info",
                                icon: "view_list",
                                title: "Survey result"
                              }
                            })
                          : _vm._e(),
                        _vm.userRoleIs(
                          _vm.$config.roles.SUPER_ADMIN,
                          _vm.$config.roles.ADMIN
                        ) &&
                        props.row.status === _vm.$config.tourStatuses.PENDING
                          ? _c("q-btn", {
                              directives: [
                                { name: "tippy", rawName: "v-tippy" }
                              ],
                              staticClass: "q-ml-sm",
                              attrs: {
                                rounded: "",
                                push: "",
                                color: "negative",
                                size: "sm",
                                outline: "",
                                icon: "cancel",
                                title: props.row.is_open_house
                                  ? "Cancel Open House"
                                  : "Cancel tour"
                              },
                              on: {
                                click: function($event) {
                                  _vm.openCancelTourConfirm(props.row)
                                }
                              }
                            })
                          : _vm._e(),
                        _vm.userRoleIs(
                          _vm.$config.roles.SUPER_ADMIN,
                          _vm.$config.roles.ADMIN
                        ) &&
                        props.row.status === _vm.$config.tourStatuses.PENDING &&
                        !props.row.survey_result_id
                          ? _c("q-btn", {
                              staticClass: "q-ml-sm",
                              attrs: {
                                to: {
                                  name: "app.tours.after-tour-survey",
                                  params: { tourId: props.row.id }
                                },
                                color: "green",
                                size: "sm",
                                rounded: "",
                                label: "submit report",
                                icon: "done",
                                outline: ""
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                }
              },
              {
                key: "top-right",
                fn: function(props) {
                  return [
                    _vm.$q.screen.gt.sm
                      ? _c(
                          "div",
                          { staticClass: "row items-center full-width" },
                          [
                            !_vm.$q.screen.lt.lg
                              ? _c(
                                  "div",
                                  { staticClass: "col-auto" },
                                  [
                                    _c("q-table-columns", {
                                      ref: "hello",
                                      staticClass: "full-width",
                                      attrs: {
                                        color: "black",
                                        label: "Visible Columns",
                                        columns: _vm.columns
                                      },
                                      on: { input: _vm.visibleColumnsChanged },
                                      model: {
                                        value: _vm.visibleColumns,
                                        callback: function($$v) {
                                          _vm.visibleColumns = $$v
                                        },
                                        expression: "visibleColumns"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              { staticClass: "col-auto" },
                              [
                                _c("q-btn", {
                                  attrs: {
                                    rounded: "",
                                    flat: "",
                                    label: "Reload data",
                                    icon: "refresh",
                                    color: "black"
                                  },
                                  on: { click: _vm.init }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col" },
                              [
                                _c("q-btn", {
                                  attrs: {
                                    round: "",
                                    flat: "",
                                    color: "black",
                                    icon: props.toggleFullscreen
                                      ? "fullscreen_exit"
                                      : "fullscreen"
                                  },
                                  on: { click: props.toggleFullscreen }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                }
              },
              {
                key: "pagination",
                fn: function(props) {
                  return _c(
                    "div",
                    { staticClass: "row flex-center q-py-sm" },
                    [
                      _c("q-btn", {
                        staticClass: "q-mr-sm",
                        attrs: {
                          dense: "",
                          size: "sm",
                          icon: "arrow_back",
                          rounded: "",
                          color: "primary",
                          disable: _vm.hasUnknownTotal
                            ? !_vm.hasPrevPage
                            : props.isFirstPage
                        },
                        on: {
                          click: function($event) {
                            props.prevPage()
                          }
                        }
                      }),
                      _c("div", { staticClass: "q-mr-sm font-small m-4" }, [
                        !_vm.hasUnknownTotal
                          ? _c("span", [
                              _vm._v(
                                "Page " +
                                  _vm._s(props.pagination.page) +
                                  " / " +
                                  _vm._s(props.pagesNumber)
                              )
                            ])
                          : _c("span", [
                              _vm._v("Page " + _vm._s(props.pagination.page))
                            ])
                      ]),
                      _c("q-btn", {
                        attrs: {
                          rounded: "",
                          dense: "",
                          size: "sm",
                          icon: "arrow_forward",
                          color: "primary",
                          disable: _vm.hasUnknownTotal
                            ? !_vm.hasNextPage
                            : props.isLastPage
                        },
                        on: {
                          click: function($event) {
                            props.nextPage()
                          }
                        }
                      })
                    ],
                    1
                  )
                }
              }
            ])
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }